__webpack_require__.p = "/invitations-prosemirror/referrals/";